import Config from "../config";
import { mapToMediaModel } from "./conversations";

export class TemplateModel {
    ID: string;
    Title: string;
    Message: string;
    Media?: MediaModel[];
    UpdatedDateTime: string;
    CreatedByID: string;
    IsPrivate: boolean;
    IsPhoneNumberLevel: boolean;
}

export class MediaModel {
    ID: string;
    Name: string;
    Url: string;
    ContentType: string;
}

export const mapToTemplate = (x: any): TemplateModel => {
    return {
        ID: x.id,
        Title: x.title,
        Message: x.message,
        UpdatedDateTime: x.updatedDateTime,
        Media: !!x.media?.length ? x.media.map(mapToMediaModel) : [],
        CreatedByID: x.createdById,
        IsPrivate: x.isPrivate,
        IsPhoneNumberLevel: x.isPhoneNumberLevel
    } as TemplateModel
}

export class FalkonEsignTemplateModel {
    ID: string;
    FileName: string;
    updatedAt: string;
}

export const mapToFalkonEsignTemplate = (x: any): FalkonEsignTemplateModel => {
    return {
        ID:x.id,
        FileName:x.files[0].file_name,
        updatedAt:x.updated_at
    }
}
